var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1065_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3242 0H7.67577C3.44334 0 0 3.44334 0 7.67583V20.3242C0 24.5567 3.44334 28 7.67577 28H20.3242C24.5567 28 28 24.5567 28 20.3242V7.67583C28 3.44334 24.5567 0 20.3242 0ZM26.3465 20.3242C26.3465 23.6449 23.645 26.3465 20.3242 26.3465H7.67577C4.35509 26.3465 1.65353 23.645 1.65353 20.3242V7.67583C1.65353 4.35509 4.35509 1.65353 7.67577 1.65353H20.3242C23.645 1.65353 26.3465 4.35509 26.3465 7.67583V20.3242Z",
    fill: "url(#paint0_linear_1065_328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6.32023C9.76533 6.32023 6.32018 9.76538 6.32018 14.0001C6.32018 18.2347 9.76527 21.6799 14 21.6799C18.2347 21.6799 21.6799 18.2347 21.6799 14C21.6799 9.76533 18.2347 6.32023 14 6.32023ZM14 20.0264C10.6771 20.0264 7.97366 17.3229 7.97366 14C7.97366 10.6771 10.6771 7.97366 14 7.97366C17.323 7.97366 20.0264 10.6771 20.0264 14.0001C20.0264 17.323 17.323 20.0264 14 20.0264ZM22.1392 3.52751C20.8526 3.52751 19.8059 4.57428 19.8059 5.86086C19.8059 7.14744 20.8526 8.19416 22.1392 8.19416C23.4258 8.19416 24.4725 7.14738 24.4725 5.8608C24.4725 4.57423 23.4258 3.52751 22.1392 3.52751ZM22.1392 6.54057C21.7644 6.54057 21.4594 6.23563 21.4594 5.8608C21.4594 5.48598 21.7644 5.18104 22.1392 5.18104C22.514 5.18104 22.819 5.48603 22.819 5.8608C22.819 6.23558 22.514 6.54057 22.1392 6.54057Z",
    fill: "url(#paint1_linear_1065_328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.138 3.52734C20.8514 3.52734 19.8047 4.57412 19.8047 5.8607C19.8047 7.14727 20.8514 8.19399 22.138 8.19399C23.4246 8.19399 24.4713 7.14722 24.4713 5.86064C24.4713 4.57406 23.4246 3.52734 22.138 3.52734ZM22.138 6.54041C21.7632 6.54041 21.4582 6.23547 21.4582 5.86064C21.4582 5.48581 21.7632 5.18087 22.138 5.18087C22.5128 5.18087 22.8177 5.48587 22.8177 5.86064C22.8177 6.23541 22.5128 6.54041 22.138 6.54041Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1065_328",
    x1: 0,
    y1: 0,
    x2: 22.9845,
    y2: 31.6431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1065_328",
    x1: 0,
    y1: 0,
    x2: 22.9845,
    y2: 31.6431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1065_328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/instaIcon.46e482ce5f4fa0ca0bd50c35fe3a9434.svg";
export { ForwardRef as ReactComponent };